






























































import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { CompanyUserCreateDto } from '@/dto/company-user/company-user-create.dto';
import { BaseUser } from '../../../services/shared/auth';
import companyUserService from '../../../services/company-user.service';
@Component({
  name: 'UserAddDialog',
})
export default class UserAddDialog extends BaseComponent {
  private companyUserCreateDto = new CompanyUserCreateDto(BaseUser);
  private loading = false;

  @Prop({ required: true }) readonly dialog: boolean;

  reset() {
    // this.userAddDialog = false;
    this.$emit('update:dialog', !this.dialog);
    this.loading = false;
    this.companyUserCreateDto = new CompanyUserCreateDto(BaseUser);
  }
  add() {
    this.loading = true;
    companyUserService.create(this.companyUserCreateDto).subscribe(
      res => {
        this.loading = false;
        this.reset();
        this.$emit('added');
      },
      err => {
        this.loading = false;
      },
    );
  }
}
